import React, { useEffect, useState } from "react";
import { Grid, TextField, MenuItem, Select, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../axiosInstance";
import Swal from 'sweetalert2';


const AddClientProdectPrice = () => {

  const [productlist, setproductlist] = useState([])
  const [countrylist, setCountryList] = useState([])

  const providerId = sessionStorage.getItem('providerId');
  const userid = sessionStorage.getItem('userid');

  const { did, cid } = useParams();

  const getProductList = async () => {
    try {

      // mulitiple url
      // let url
      // if(providerId !== '0'){
      //   url =`/userproduct?DISID=${userid}`
      // }else
      //   url =`/products?page=1`
      // }

      const params =
        providerId !== '0'
          ? { DISID: userid, CLID: cid }
          : { page: 1, CLID: cid };

      let url = providerId !== '0' ? `/userproduct` : `/products`
      const response = await api.get(url, { params });
      console.log("response", response?.data?.data);

      if (!response?.data?.data || (Array.isArray(response?.data?.data) && response?.data?.data.length === 0)) {
        Swal.fire({
          icon: "warning",
          title: "Action not allowed",
          text: "This client already has a product.",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/client"); // 👈 redirect to root
          }
        });
      }

      // Ensure it's always an array of objects with { id, name }
      setproductlist(response?.data?.data)

    } catch (error) {
      console.error('Error fetching product list:', error);
      setproductlist([]); // Fallback to an empty array on error
    }
  };


  console.log("productid and value", productlist);




  useEffect(() => {
    getProductList()
  }, [])


  const distributors = [
    { id: 1, name: "Distributor A" },
    { id: 2, name: "Distributor B" },
  ];
  const products = [
    ...productlist
  ];

  const onSubmit = (data) => {
    console.log("Sending data to API:", data);
  };

  const [formData, setFormData] = useState({
    product_id: "",
    user_id: cid,
    user_parent_id: providerId !== '0' ? userid : 1,
    price: "",
    type: 2,
    country: '',
    language: '',
    organisation: '',
    mobile_number: ''
  });

  const [dataArray, setDataArray] = useState([]);
  const [editIndex, setEditIndex] = useState(null);


  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddOrUpdate = () => {
    if (formData.product_id && formData.price) {
      if (editIndex !== null) {
        const updatedData = [...dataArray];
        updatedData[editIndex] = { id: editIndex + 1, ...formData };
        setDataArray(updatedData);
        setEditIndex(null);
      } else {
        setDataArray((prev) => [
          ...prev,
          { id: prev.length + 1, ...formData },
        ]);
      }
      setFormData({ product_id: "", price: "" });
    }
  };

  const handleEdit = (index) => {
    setFormData(dataArray[index]);
    setEditIndex(index);
  };

  const handleDelete = (id) => {
    setDataArray(dataArray.filter((row) => row.id !== id));
  };

  const handleSubmit = async () => {
    try {
      // const requestData = dataArray.map(({ id, ...rest }) => ({
      //   ...rest,
      //   price: Number(rest.price),
      // }));

      console.log("API Response:", formData);

      const requestData =
        dataArray.length > 0
          ? dataArray.map(({ id, ...rest }) => ({
            ...rest,
            price: Number(rest.price),
          }))
          : [{
            ...formData,
            price: Number(formData.price),
          }];
      const response = await api.post(`/userproduct`, ...requestData);

      Swal.fire({
        icon: "success",
        title: "success",
        text: response.data?.message,
      });
      navigate(-1)
    } catch (error) {
      console.error("Error submitting data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message,
      });
    }
  };

  const columns = [
    // { field: "distributor", headerName: "Distributor", flex: 1 },
    { field: "product_id", headerName: "Product", flex: 1 },
    { field: "price", headerName: "Price", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: (params) => (
        <>
          <Button size="small" onClick={() => handleEdit(params.row.id - 1)}>
            Edit
          </Button>
          <Button size="small" color="error" onClick={() => handleDelete(params.row.id)}>
            Delete
          </Button>
        </>
      ),
      flex: 1,
    },
  ];


  const selectedProduct = products.find(p => p.id === formData.product_id);

  useEffect(() => {
    if (products.length > 0 && !formData.product_id) {
      setFormData((prev) => ({
        ...prev,
        product_id: products[0].id,  // set first product
      }));
    }
  }, [products]);



  const fetchCountry = async () => {
    try {
      const countryresponse = await api.get(`/listcountries`)
      console.log("ountryresponse", countryresponse.data.data)
      setCountryList(countryresponse.data.data)
    }
    catch (error) {
      console.log("error", error)
    }

  }

  useEffect(() => {
    fetchCountry()
  }, [])

  console.log("product price", selectedProduct?.price);
  return (
    <div style={{ width: "100%", margin: "auto" }}>
      {/* <div>
        <button className='btn btn-primary m-1' onClick={() => navigate(`/assignreseller`)}>Back</button>
      </div> */}
      <div className="form-container">
        <Grid container spacing={2}>
          {/* Product */}
          <Grid item xs={12} sm={6} md={4}>
            <Select
              value={formData.product_id}
              onChange={(e) => handleChange("product_id", e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value="" disabled>
                Select Product
              </MenuItem>
              {products.map((prod) => (
                <MenuItem key={prod.id} value={prod.id}>
                  {prod.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          {/* Price */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              type="number"
              value={formData.price}
              onChange={(e) => handleChange("price", e.target.value)}
              fullWidth
              placeholder={`Price : ${selectedProduct?.price || 0}`}
              inputProps={{
                min: selectedProduct?.price || 0,
              }}
              helperText={
                formData.price &&
                  Number(formData.price) < (selectedProduct?.price || 0)
                  ? `Price must be at least ${selectedProduct?.price}`
                  : ""
              }
              sx={{
                "& .MuiInputBase-input::placeholder": {
                  fontSize: "15px",
                },
              }}
            />
          </Grid>

          {/* Date */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              type="tel"
              value={formData.date}
              onChange={(e) => handleChange("mobile_number", e.target.value)}
              fullWidth
              placeholder="Mobile Number"
            />
          </Grid>

          {/* Organisation */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              type="text"
              value={formData.organisation}
              onChange={(e) => handleChange("organisation", e.target.value)}
              fullWidth
              placeholder="Organisation"
            />
          </Grid>

          {/* Language */}
          <Grid item xs={12} sm={6} md={4}>
            <Select
              value={formData.language}
              onChange={(e) => handleChange("language", e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value="" disabled>Select Language</MenuItem>
              <MenuItem value="English">English</MenuItem>
              <MenuItem value="Arabic">Arabic</MenuItem>
              <MenuItem value="Malayalam">Malayalam</MenuItem>
            </Select>
          </Grid>

          {/* Country */}
          <Grid item xs={12} sm={6} md={4}>
            <Select
              value={formData.country}
              onChange={(e) => handleChange("country", e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value="" disabled>
                Select Country
              </MenuItem>
              {countrylist.map((prod) => (
                <MenuItem key={prod.id} value={prod.code}>
                  {prod.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          {/* Button */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  onClick={handleAddOrUpdate}
                  fullWidth
                >
                  {editIndex !== null ? "Update" : "Add"}
                </Button>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setDataArray([])}
                  fullWidth
                >
                  Cancel
                </Button>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  fullWidth
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </div>

      <div style={{ height: 300, width: "100%", marginTop: 20 }}>
        <DataGrid
          rows={dataArray}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </div>
      <div className="d-flex gap-4 mt-4">

      </div>


    </div>
  );
};

export default AddClientProdectPrice;
